import React from "react";
import "./Hero.css";
import Type from "./Type";
import { Link, NavLink } from "react-router-dom";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-wrap">
          <div className="hero-left">
            <div className="typewriter-badge-hero">
              <Type />
            </div>
            <div className="hero-tag-row">
              <span className="hero-tag-line" />
            </div>
            <div className="hero-tag-row">
              <span className="hero-tag">DIGITAL MARKETING AGENCY</span>
            </div>
            <h1 className="hero-title">
              Grow Your Brand Faster
              <br />
              with GoKwik Media
            </h1>
            <p className="hero-desc">
              We deliver data-driven digital marketing strategies that boost
              visibility, generate leads, and maximize ROI.
            </p>
            <div className="hero-btn-row">
              <div className="hero-card-footer">
                <Link to="/contact">
                  <button className="hero-read-more">Get Started</button>
                </Link>
              </div>
            </div>
            <img
              src="/assets/hero/plane.png"
              alt="rocket"
              className="hero-rocket"
            />
            <img src="/assets/hero/dots.png" alt="dots" className="hero-dots" />
          </div>

          <div className="hero-right">
            {/* <div className="hero-img-bg"> */}
            <img
              src="/assets/hero/hero.png"
              alt="GoKwik Media"
              className="hero-main-img"
            />
            <img
              src="/assets/hero/shadow.png"
              alt="shadow"
              className="hero-shadow"
            />
            {/* </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;


